export const TANSTACK_QUERY_PERSIST_MAX_AGE_MS = 1000 * 60 * 60 * 8; // 8 hours
